import { ICreateControleEnergiaUseCase } from "../../../presentation/useCases/create/create_controle_energia_use_case";
import { CreateControleEnergiaRequestModel, CreateControleEnergiaResponseModel } from "../../models/obras_sustentabilidade_model";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateControleEnergiaUseCase
 */

export class CreateControleEnergiaUseCase implements ICreateControleEnergiaUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async createControleEnergia(model: CreateControleEnergiaRequestModel): Promise<CreateControleEnergiaResponseModel> {
    return await this.repository.createControleEnergia(model);
  }
}
